import * as React from 'react';
import { IMedia, IGenre, IPerson, ICity } from '../../interfaces';
import Favorite from '../parts/Favorite';
import { NavLink } from 'react-router-dom';
import { transliterate } from '../../utils/functions';

interface IProps {
    slide: IMedia,
    url?: string
}

export default class Clip extends React.Component<IProps, any>{

    render() {
        let { slide } = this.props;

        return (
            <div className="t">
                <div className="img img_box">
                    <a href="#!">
                        <img src={slide.fullFirstFrame} />
                    </a>

                    <div className="icons">
                        <ul>
                            <li>
                                <Favorite media={slide}/>    
                            </li>
                            <li className="transform">
                                <NavLink to={"/" + (this.props.url ? this.props.url : "clip") + "/" + transliterate((slide.artist ? slide.artist.full + "-" : "") + slide.name) + "/" + slide.media_id}>
                                    <i className="fa fa-play-circle-o"></i>
                                </NavLink>
                            </li>
                        </ul>
                    </div>

                </div>
                {slide.artist && <h4 className="text-center"> <NavLink to={"/singer/" + transliterate(slide.artist.full) + "/" + slide.artist.person_id} title={slide.artist.full}> {slide.artist.full} </NavLink> </h4>}
                <h1 className="text-center"> <NavLink to={"/clip/" + transliterate((slide.artist ? slide.artist.full + "-" : "") + slide.name) + "/" + slide.media_id} title={slide.name}> {slide.name} </NavLink> </h1>
            </div>
        );
    }
}